import {
  CORE_LOAD_ALL_IOTACCESSORY_REQUEST,
  CORE_LOAD_ALL_IOTACCESSORY_SUCCESS,
  CORE_LOAD_ALL_IOTACCESSORY_FAILURE,

  CORE_LOAD_IOTACCESSORY_REQUEST,
  CORE_LOAD_IOTACCESSORY_SUCCESS,
  CORE_LOAD_IOTACCESSORY_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allIOTAccessory: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_IOTACCESSORY_REQUEST:
        return requestState
      case CORE_LOAD_ALL_IOTACCESSORY_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_IOTACCESSORY_FAILURE:
        return initialState
      default:
        return state
    }
  },
  IOTAccessoryInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_IOTACCESSORY_REQUEST:
        return requestState
      case CORE_LOAD_IOTACCESSORY_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_IOTACCESSORY_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerIOTAccessory.js